/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import { connect } from 'react-redux';
import cn from 'classnames';

import { toggleVideoSound } from '../../actions';
import get from '../../helpers/get';

import { itemType } from '../../propTypes/ourStoryItem';
import { SANS_SERIF } from '../../propTypes';
import theme, {
  getFontFamilyAndWeightFor,
  expandAbsolutely,
} from '../../styles/theme';
import { openFullscreen } from '../../helpers/fullscreen';
import isFullScreen from '../../helpers/isFullScreen';

import ImageOrVideo from '../ImageOrVideo';
import CtaButton from '../CtaButton';
import PlayButton from './PlayButton';
import VideoControls from './VideoControls';

class Item extends Component {
  state = {
    playButtonClicked: false,
    controlsVisible: false,
    paused: false,
    currentTime: 0,
  };

  componentDidUpdate(prevProps) {
    const { selected } = this.props;
    const { playButtonClicked } = this.state;
    if (!selected && prevProps.selected && playButtonClicked) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ paused: true });
      this.showControls();
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      // eslint-disable-next-line no-undef
      window.clearInterval(this.interval);
    }
    if (this.animationFrame) {
      // eslint-disable-next-line no-undef
      window.cancelAnimationFrame(this.animationFrame);
    }
  }

  onPlay = e => {
    const { onPlayClicked } = this.props;
    if (this.video) {
      this.video.currentTime = 0;
      this.video.focus();
    }
    this.setState({ playButtonClicked: true });
    onPlayClicked();
    this.showControls();
    e.stopPropagation();
  };

  onProgressClicked = percent => {
    if (this.video) {
      this.video.currentTime = this.video.duration * (percent / 100);
    }
  };

  onTogglePlayback = () => {
    const { paused } = this.state;
    if (this.video) {
      this.setState({ paused: !paused });
    }
  };

  onToggleFullScreen = e => {
    if (this.video) {
      openFullscreen(this.video);
      this.video.focus();
    }
    e.stopPropagation();
  };

  onVideoClicked = () => {
    if (!isFullScreen()) {
      this.onTogglePlayback();
      this.showControls();
    }
  };

  onSpacePressed = e => {
    if (e.keyCode === 32) {
      if (!isFullScreen()) {
        e.preventDefault();
        this.onTogglePlayback();
        this.showControls();
      }
    }
  };

  onKeyPressed = () => {
    this.showControls();
  };

  onFullscreenPlayPause = () => {
    if (isFullScreen()) {
      this.onTogglePlayback();
    }
  };

  setVideoRef = ref => {
    this.video = ref;
    if (this.animationFrame) {
      // eslint-disable-next-line no-undef
      window.cancelAnimationFrame(this.animationFrame);
    }
    if (this.video) {
      this.updateVideoPosition();
    }
  };

  showControls = () => {
    this.setState({ controlsVisible: true });
    if (this.interval) {
      // eslint-disable-next-line no-undef
      window.clearInterval(this.interval);
    }
    // eslint-disable-next-line no-undef
    this.interval = window.setInterval(() => {
      const { paused } = this.state;
      if (!paused) {
        this.setState({ controlsVisible: false });
      }
    }, 2000);
  };

  updateVideoPosition = () => {
    const { currentTime } = this.state;
    if (this.video) {
      if (currentTime !== this.video.currentTime) {
        this.setState({ currentTime: this.video.currentTime });
      }
      // eslint-disable-next-line no-undef
      this.animationFrame = window.requestAnimationFrame(this.updateVideoPosition);
    }
  };

  render() {
    const {
      classes, className, item, selected,
    } = this.props;
    const {
      paused, playButtonClicked, currentTime, controlsVisible,
    } = this.state;

    const leftAligned = item.position === 'left';
    const sansSerif = item.title_typography === SANS_SERIF;

    return (
      <div
        key={item.title.text}
        className={cn(classes.item, className, item.orientation, { [classes.left]: leftAligned })}
      >
        <div className={cn(classes.content, { [classes.contentLeft]: leftAligned })}>
          <div>
            <h3 className={cn(classes.title, sansSerif ? 'sansSerif' : 'serif')}>
              {item.title.text}
            </h3>
            {item.copy && (
            <div
              className={classes.copy}
              dangerouslySetInnerHTML={{ __html: item.copy.html }}
            />
            )}
            {item.cta && <CtaButton link={item.cta} />}
          </div>
        </div>
        <div
          role="Img" // eslint-disable-line jsx-a11y/aria-role
          className={cn(classes.image, { hideCursor: item.hero_video && !controlsVisible })}
          onMouseMove={item.hero_video ? this.showControls : null}
          onClick={item.hero_video ? this.onVideoClicked : null}
          onKeyDown={item.hero_video ? this.onKeyPressed : null}
        >
          <ImageOrVideo
            imageClassName={classes.imageAspect}
            defaultAlt={item.title.text}
            image={item.hero_image}
            video={item.hero_video}
            autoPlay
            videoPaused={paused || !selected}
            restartOnPause={false}
            videoClassName={classes.audioButton}
            showAudioButton={false}
            setVideoRef={this.setVideoRef}
            playButtonClicked={playButtonClicked}
            onSpacePressed={this.onSpacePressed}
            onVideoPaused={this.onFullscreenPlayPause}
            onVideoPlay={this.onFullscreenPlayPause}
          />
          {item.hero_video && (
            <>
              <PlayButton
                className={cn(classes.playButton, { remove: playButtonClicked })}
                onClick={this.onPlay}
              />
              <VideoControls
                className={cn(
                  classes.controls,
                  { remove: !playButtonClicked },
                  { hide: playButtonClicked && !controlsVisible },
                )}
                onFullScreenToggle={this.onToggleFullScreen}
                currentTime={currentTime}
                duration={this.video && this.video.duration}
                onProgressClicked={this.onProgressClicked}
                onTogglePlayback={this.onTogglePlayback}
                playing={!paused}
                onSpacePressed={this.onSpacePressed}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}

Item.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  item: itemType.isRequired,
  selected: PropTypes.bool,
  onPlayClicked: PropTypes.func,
};

Item.defaultProps = {
  selected: false,
  className: undefined,
  onPlayClicked: undefined,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  onPlayClicked: () => dispatch(toggleVideoSound(false)),
});

export const getImageAspect = item => {
  const imageAspect = get(item, ['hero_video', 'aspect']) || get(item, ['hero_image', 'aspect'])
    || (item.orientation === 'landscape' ? 16 / 9 : 640 / 860);
  return imageAspect;
};

const getMobileImageAspect = item => get(item, ['hero_image', 'alternatives', 'Mobile', 'aspect'])
  || getImageAspect(item);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet({
    item: {
      width: '100%',
      visibility: ({ selected }) => (selected ? 'initial' : 'hidden'),
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column-reverse',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-start',
        flexDirection: 'row',
      },
      '&.landscape $image': {
        width: '100%',
        [theme.breakpoints.up('md')]: {
          width: '60%',
        },
        [theme.breakpoints.up('lg')]: {
          width: '70%',
        },
      },
      '&.landscape $content': {
        width: '100%',
        [theme.breakpoints.up('md')]: {
          width: '40%',
        },
        [theme.breakpoints.up('lg')]: {
          width: '30%',
        },
      },
    },
    left: {
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row-reverse',
      },
    },
    image: {
      position: 'relative',
      width: '100%',
      marginBottom: theme.spacing.vertical.sm,
      color: theme.colors.white,
      overflow: 'hidden',
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        width: '50%',
      },
      '&.hideCursor': {
        cursor: 'none',
      },
    },
    imageAspect: {
      '&:before': {
        paddingTop: ({ item }) => `${(1 / getMobileImageAspect(item)) * 100}%`,
      },
      [theme.breakpoints.up('md')]: {
        '&:before': {
          paddingTop: ({ item }) => `${(1 / getImageAspect(item)) * 100}%`,
        },
      },
    },
    content: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        marginRight: 32,
        width: '50%',
      },
    },
    contentLeft: {
      [theme.breakpoints.up('md')]: {
        marginRight: 0,
        marginLeft: 32,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    title: {
      '&.serif': getFontFamilyAndWeightFor('heading'),
      '&.sansSerif': getFontFamilyAndWeightFor('bold'),
      letterSpacing: '0.3px',
      marginBottom: theme.spacing.vertical.xs,
      marginTop: 0,
      fontSize: 38,
      lineHeight: 1.2,
      whiteSpace: 'pre-line',
      [theme.breakpoints.up('md')]: {
        maxWidth: 400,
        fontSize: 42,
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 52,
        maxWidth: 400,
      },
    },
    copy: {
      lineHeight: 1.6,
      [theme.breakpoints.up('md')]: {
        maxWidth: 430,
      },
      '&:not(:last-child)': {
        marginBottom: theme.spacing.vertical.sm,
      },
      '& p, & li, & a': {
        fontSize: 16,
        lineHeight: 1.5,
        color: 'currentColor',
      },
      '& ul': {
        listStyle: 'initial',
      },
      '& p a:not(.button)[href]': {
        color: 'currentColor',
        fontFamily: 'inherit !important', // cannot override global style without !important :(
      },
      '& a:hover, & a:focus': {
        color: theme.colors.secondary,
        textDecoration: 'underline',
        textUnderlinePosition: 'under',
      },
    },
    playButton: {
      ...expandAbsolutely,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: `${theme.colors.blackOpacity30} !important`,
      opacity: 1,
      transition: 'opacity 0.25s ease-in-out',
      '&.remove': {
        display: 'none',
      },
      '& svg': {
        color: theme.colors.white,
      },
      // to fix not visible outline on Safari and Firefox because (overflow: hidden for parent)
      // focus-visible isn't supported on Safari
      '&:focus': {
        outlineOffset: -5,
      },
      '&:focus-visible': {
        outlineOffset: -1,
      },
    },
    circle: {
      display: 'block',
      width: 80,
      height: 80,
      borderRadius: '50%',
      borderWidth: 1,
      borderColor: 'currentColor',
      borderStyle: 'solid',
      '&:after': {
        content: '"play"',
      },
    },
    controls: {
      position: 'absolute',
      color: theme.colors.white,
      bottom: 0,
      left: 0,
      right: 0,
      opacity: 1,
      padding: [0, 16],
      transition: 'opacity 0.25s ease-in-out',
      [theme.breakpoints.up('md')]: {
        padding: [16, 32],
      },
      '&.remove': {
        display: 'none',
      },
      '&.hide': {
        opacity: 0,
        pointerEvents: 'none',
      },
    },
  }),
)(Item);
